// TSS vite/04 §"Endpoint paths".
// URL knowledge lives here: a backend rename touches one file.
// No leading slash — axios joins baseURL + url with a single slash.

export const projectPaths = {
    list:   ()   => 'admin/projects',
    detail: (id) => `admin/projects/${id}`,
    // Who works on this project. Takes ?repository_id=N to narrow it to one
    // repository — and that answer still includes the teams with no repository
    // restriction, because they reach it too.
    teams:  (id) => `admin/projects/${id}/teams`,
};
